import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const WHATSAPP_NUMBERS = {
  LK: '94722144722',    // Sri Lanka
  DEFAULT: '6589180134' // Singapore (Global)
};

const WhatsAppButton = () => {
  const [isHovered, setIsHovered] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState(WHATSAPP_NUMBERS.DEFAULT);

  useEffect(() => {
    // Detect user's country via IP geolocation
    const detectCountry = async () => {
      try {
        const response = await fetch('https://ipapi.co/json/', {
          signal: AbortSignal.timeout(4000)
        });
        if (response.ok) {
          const data = await response.json();
          if (data.country_code === 'LK') {
            setPhoneNumber(WHATSAPP_NUMBERS.LK);
          }
        }
      } catch (err) {
        // Fallback: try secondary API
        try {
          const res = await fetch('https://ip-api.com/json/?fields=countryCode', {
            signal: AbortSignal.timeout(3000)
          });
          if (res.ok) {
            const data = await res.json();
            if (data.countryCode === 'LK') {
              setPhoneNumber(WHATSAPP_NUMBERS.LK);
            }
          }
        } catch {
          // Keep default (Singapore) if both APIs fail
        }
      }
    };

    detectCountry();
  }, []);

  const handleClick = () => {
    window.open(`https://wa.me/${phoneNumber}`, '_blank', 'noopener,noreferrer');
  };

  return (
    <motion.button
      onClick={handleClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className="fixed bottom-8 right-8 z-[90] flex items-center group"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 2, type: 'spring', stiffness: 260, damping: 20 }}
    >
      {/* Tooltip */}
      <AnimatePresence>
        {isHovered && (
          <motion.div
            initial={{ opacity: 0, x: -10, scale: 0.9 }}
            animate={{ opacity: 1, x: 0, scale: 1 }}
            exit={{ opacity: 0, x: -10, scale: 0.9 }}
            transition={{ duration: 0.2 }}
            className="absolute right-full mr-3 bg-white text-slate-800 text-sm font-medium px-4 py-2.5 rounded-xl shadow-lg border border-slate-100 whitespace-nowrap pointer-events-none"
          >
            Chat on WhatsApp
            <div className="absolute top-1/2 -right-1.5 -translate-y-1/2 w-3 h-3 bg-white border-r border-t border-slate-100 rotate-45" />
          </motion.div>
        )}
      </AnimatePresence>

      {/* Pulse ring */}
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20" />

      {/* Button */}
      <motion.div
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        className="relative w-14 h-14 rounded-full bg-[#25D366] flex items-center justify-center shadow-lg shadow-[#25D366]/30 hover:shadow-xl hover:shadow-[#25D366]/40 transition-shadow"
      >
        <svg viewBox="0 0 32 32" className="w-7 h-7 fill-white">
          <path d="M16.004 0h-.008C7.174 0 0 7.176 0 16c0 3.5 1.128 6.744 3.046 9.378L1.054 31.29l6.118-1.958A15.93 15.93 0 0 0 16.004 32C24.826 32 32 24.822 32 16S24.826 0 16.004 0zm9.335 22.594c-.39 1.1-1.932 2.014-3.168 2.28-.846.18-1.95.324-5.67-1.218-4.762-1.972-7.826-6.81-8.064-7.124-.23-.314-1.928-2.568-1.928-4.898 0-2.328 1.22-3.472 1.654-3.948.39-.428 1.028-.624 1.638-.624.198 0 .376.01.536.018.472.02.71.048 1.022.788.39.926 1.34 3.264 1.458 3.504.12.24.24.554.076.868-.154.322-.288.464-.528.736-.24.272-.472.478-.712.77-.22.256-.468.53-.198 1.004.27.468 1.2 1.978 2.576 3.204 1.77 1.578 3.26 2.068 3.722 2.296.468.228.742.19 1.012-.114.278-.314 1.188-1.384 1.504-1.862.308-.472.622-.39 1.046-.234.43.152 2.706 1.276 3.17 1.508.468.234.78.348.894.542.112.198.112 1.128-.278 2.228z" />
        </svg>
      </motion.div>
    </motion.button>
  );
};

export default WhatsAppButton;